import React, { useContext, useState } from 'react';  // Adicione useState
import { Link, useNavigate } from 'react-router-dom';  // Adicione useNavigate
import PageTransition from '../components/PageTransition';
import { LanguageContext } from '../context/LanguageContext';
import WorkshopDrawer from '../components/WorkshopDrawer';  // Importe o novo componente

export default function Workshops() {
  const { language } = useContext(LanguageContext);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);  // Adicione este estado
  const navigate = useNavigate();  // Adicione useNavigate

  const texts = {
    EN: {
      back: "back",
      title: 'Workshops',
      upcomingEvents: 'Upcoming Events',
      pastEvents: 'Past Events',
      // Workshop VR
      workshopTitle: 'Sculpting Pixels: Creating Accessible Virtual Environments',
      modality: 'Online (Synchronous)',
      duration: '2 hours',
      date: 'March 15, 2025',
      time: '10:00 AM to 12:00 PM',
      format: 'Theoretical-practical',
      investment: 'Free',
      requirements: 'Computer with internet access; basic HTML knowledge (desired)',
      accessibility: 'Presentation in Brazilian Sign Language (Libras)',
      description: 'Participants will be introduced to the technologies used in the production of the "deepVIEW" artwork and will be able to create their own immersive virtual environment.',
      enroll: 'Enroll',
      // Open Studio
      openStudioTitle: 'Open Studio',
      openStudioDate: 'November 17, 2024',
      openStudioDescription: 'A space for artistic experimentation and creative exchange.',
      readMore: 'Read More',
      // Raw Machine ASMR
      asmrTitle: 'Raw Machine: ASMR box',
      asmrDate: 'December 22, 2023',
      asmrTime: '1:00 PM',
      asmrLocation: 'Núcleo Municipal de Artes e Cultura Roberto Farath',
      
      // Raw Machine Boombox
      boomboxTitle: 'Raw Machine: boombox',
      boomboxDate: 'July 09, 2023',
      boomboxLocation: 'Sesc Rio Preto',
      
      // CNC Workshop
      cncTitle: 'Workshop - Self-Portrait Recording with CNC Laser',
      cncDate: 'Past Event',
      cncTime: '7:00 PM to 9:00 PM',
      cncLocation: 'SESC Rio Preto',
      cncDetails: 'Free. Registration at the venue 30 minutes before. Age 14+',
      cncDescription: 'This 4-meeting workshop aims to introduce participants to digital manufacturing technology with CNC laser. At the end, a picture frame will be developed with an image chosen by the participant. Concepts such as safe handling of a desktop CNC laser, use of free software such as Laser GRBL and Inkscape, and digital manufacturing will be covered.',
      // Study Group
      studyGroupTitle: 'Contemporary Art Study Group',
      studyGroupDescription: 'More information coming soon',
    },
    PT: {
      back: "retornar",
      title: 'Cursos e Oficinas',
      upcomingEvents: 'Próximas Atividades',
      pastEvents: 'Atividades Anteriores',
      // Workshop VR
      workshopTitle: 'Esculpindo pixels: criando ambientes virtuais acessíveis',
      modality: 'Online (Síncrono)',
      duration: '2 horas',
      date: '15 de Março de 2025',
      time: '10h às 12h',
      format: 'Teórico-prático',
      investment: 'Gratuito',
      requirements: 'Acesso a um computador com internet; conhecimentos básicos de HTML (desejável)',
      accessibility: 'Apresentação em Libras',
      description: 'Os participantes serão introduzidos às tecnologias utilizadas na produção da obra "deepVIEW" e poderão criar seu próprio ambiente virtual imersivo.',
      enroll: 'Inscreva-se',
      // Ateliê Aberto
      openStudioTitle: 'Ateliê Aberto: gravura no campo expandido',
      openStudioDate: '17 de Novembro de 2024',
      openStudioDescription: 'Um espaço para experimentação artística e troca criativa.',
      readMore: 'Saiba Mais',
      // Raw Machine ASMR
      asmrTitle: 'Raw Machine: construção de um ASMR box',
      asmrDate: '22 de Dezembro de 2023',
      asmrTime: '13h00',
      asmrLocation: 'Núcleo Municipal de Artes e Cultura Roberto Farath',
      
      // Raw Machine Boombox
      boomboxTitle: 'Raw Machine: construção de uma boombox',
      boomboxDate: '09 de Julho de 2023',
      boomboxLocation: 'Sesc Rio Preto',
      
      // CNC Workshop
      cncTitle: 'Gravação de Autorretrato com CNC Laser',
      cncDate: '10/01/2023 à 13/01/2023',
      cncTime: '19h00 às 21h00',
      cncLocation: 'SESC Rio Preto',
      cncDetails: 'Grátis. Inscrições no local da atividade com 30 minutos de antecedência. 14 anos',
      cncDescription: 'Esta oficina de 4 encontros tem por objetivo introduzir os participantes à tecnologia de fabricação digital com CNC laser. Ao final dela, será desenvolvido um porta retrato com imagem escolhida pelo participante. Serão abordados conceitos como manuseio seguro de uma CNC laser do tipo desktop, utilização de softwares-livres como Laser GRBL e Inkscape e da fabricação digital.',
      // Study Group
      studyGroupTitle: 'Grupo de estudos em Arte Contemporânea',
      studyGroupDescription: 'Em breve mais informações',
    }
  };

  const t = texts[language];

  const eventCardStyle = {
    backgroundColor: '#f5f5f5',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  };

  const upcomingEventCardStyle = {
    backgroundColor: '#f5f5f5',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  };

  const pastEventCardStyle = {
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    border: '1px solid #e0e0e0'
  };

  const sectionStyle = {
    marginBottom: '40px'
  };

  const buttonStyle = {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "20px",
    backgroundColor: "#4285F4",
    color: "#fff",
    border: "none",
    borderRadius: "4px"
  };

  return (
    <PageTransition>
      <div className="page-container">
        <Link to="/" className="back-button">&lt; {t.back}</Link>
        <h1>{t.title}</h1>

        {/* Upcoming Events Section */}
        <div style={sectionStyle}>
          <h2>{t.upcomingEvents}</h2>
          <div style={upcomingEventCardStyle}>
            <h3>{t.workshopTitle}</h3>
            <p><strong>Data:</strong> {t.date}</p>
            <p><strong>Horário:</strong> {t.time}</p>
            <p><strong>Modalidade:</strong> {t.modality}</p>
            <p><strong>Formato:</strong> {t.format}</p>
            <p><strong>Duração:</strong> {t.duration}</p>
            <p><strong>Investimento:</strong> {t.investment}</p>
            <p><strong>Requisitos:</strong> {t.requirements}</p>
            <p><strong>Acessibilidade:</strong> {t.accessibility}</p>
            <p>{t.description}</p>
            {/*<button 
              style={buttonStyle}
              onClick={() => setIsDrawerOpen(true)}  // Modifique esta linha
            >
              {t.enroll}
            </button>*/}
          </div>

          <div style={upcomingEventCardStyle}>
            <h3>{t.studyGroupTitle}</h3>
            <p>{t.studyGroupDescription}</p>
          </div>
        </div>

        {/* Past Events Section */}
        <div style={sectionStyle}>
          <h2>{t.pastEvents}</h2>
          
          <div style={pastEventCardStyle}>
            <h3>{t.openStudioTitle}</h3>
            <p><strong>Data:</strong> {t.openStudioDate}</p>
            <p>{t.openStudioDescription}</p>
            <button 
              style={buttonStyle}
              onClick={() => navigate("/workshops/atelie-aberto")}  // Use navigate ao invés de window.open
            >
              {t.readMore}
            </button>
          </div>

          <div style={pastEventCardStyle}>
            <h3>{t.asmrTitle}</h3>
            <p><strong>Data:</strong> {t.asmrDate}</p>
            <p><strong>Horário:</strong> {t.asmrTime}</p>
            <p><strong>Local:</strong> {t.asmrLocation}</p>
            <button 
              style={buttonStyle}
              onClick={() => window.open("https://example.com/asmr-box", "_blank")}
            >
              {t.readMore}
            </button>
          </div>

          <div style={pastEventCardStyle}>
            <h3>{t.boomboxTitle}</h3>
            <p><strong>Data:</strong> {t.boomboxDate}</p>
            <p><strong>Local:</strong> {t.boomboxLocation}</p>
            <button 
              style={buttonStyle}
              onClick={() => window.open("https://example.com/boombox", "_blank")}
            >
              {t.readMore}
            </button>
          </div>

          <div style={pastEventCardStyle}>
            <h3>{t.cncTitle}</h3>
            <p><strong>Data:</strong> {t.cncDate}</p>
            <p><strong>Horário:</strong> {t.cncTime}</p>
            <p><strong>Local:</strong> {t.cncLocation}</p>
            <p><strong>Informações:</strong> {t.cncDetails}</p>
            <p>{t.cncDescription}</p>
            <button 
              style={buttonStyle}
              onClick={() => window.open("https://example.com/cnc-workshop", "_blank")}
            >
              {t.readMore}
            </button>
          </div>
        </div>
      </div>
      <WorkshopDrawer 
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        workshopTitle={t.workshopTitle}
      />
    </PageTransition>
  );
}